import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import {
    BrowserRouter,
    Route,
    Routes,
    Navigate
} from 'react-router-dom';

import './App.css';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/js/main';

import Albums from './pages/Album';
import ScrollToTop from './Component/ScrollToTop';

function App() {
    return (
        <BrowserRouter>

            <ScrollToTop />

            <Routes>

                {/* When opening localhost:5000,
                    automatically go to the first category */}
                <Route
                    path="/"
                    element={<Navigate to="/album" replace />}
                />

                {/* Album main page */}
                <Route
                    path="/album"
                    element={<Albums />}
                />

                {/* Category album */}
                <Route
                    path="/album/category/:id/:name"
                    element={<Albums />}
                />

                {/* Subcategory album */}
                <Route
                    path="/album/subcategory/:id/:name"
                    element={<Albums />}
                />

            </Routes>

        </BrowserRouter>
    );
}

export default App;